import { render, staticRenderFns } from "./base_report.vue?vue&type=template&id=205bc528&scoped=true&"
import script from "./base_report.vue?vue&type=script&lang=js&"
export * from "./base_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205bc528",
  null
  
)

export default component.exports